export default __webpack_public_path__ + "static/media/img1pro8.30ce12ef.jpeg";